import * as React from 'react';
import ReactTable from "react-table";
import 'react-table/react-table.css'
import { Form, Text, Select } from 'react-form';
import { api } from '@src/services/api';
import {isReadOnly} from 'services/user';
import { checkLevel } from "@src/services/user";
import { _ } from "@src/services/i18n";
import { Switch } from "@src/services/form";
import { classNames, css, mixin, vars, defaultProps, formatters } from '@src/services/theme';
import { ProtoList, PropsList, StateList } from '@src/components/Proto';
import { SettingsDevice as Edit, Box } from '@src/components';

// typing
interface LocalProps extends PropsList {
    
}
interface LocalState extends StateList {
}

// style
const style = css`
    form {
        ${mixin.form}
    }
`;

// component
export class Device extends ProtoList<LocalProps, LocalState> {
    
	// render
	render() {
        const _loading = this.loading();
        if (_loading) return _loading;
        const { cpt, urlShow, urlCreate, urlUpdate } = this.props;
        const { loading, action, editing, data, search = {}, items = [], tableProps, editProps } = this.state;
        
        const columns = [
            // { ...defaultProps.columns.id },
            { Header: _('col_serialno', 'SettingsDevice'), accessor: 'serialno' },
            { Header: _('col_description', 'SettingsDevice'), accessor: 'description' },
            { Header: _('col_customer', 'SettingsDevice'), accessor: 'battery.customer.description' },
            { Header: _('col_battery', 'SettingsDevice'), accessor: 'battery.serialno' },
        ];
        
        let localTableProps;
        if (items) {
            localTableProps = {
                ...defaultProps.table(),
                ...tableProps,
            }
        }
        localTableProps.loading = loading;
        
        let localEditProps = {
            ...editProps
        } as any;
        if (action === "EDIT" && !isReadOnly() ) {
            localEditProps.id = editing;
        }

        if (!checkLevel('hyster')) {
            this.Toolbar = () => (<></>);
            localTableProps.getTrProps = () => { return {}; };
        }

		return (
            <>
            {(action === "CREATE" || action === "EDIT") && !isReadOnly() &&
            <Edit {...localEditProps} />
            }
            <Box
                title={_('list_title', 'SettingsDevice')}
                toolbar={!isReadOnly()?this.Toolbar:null}
                collapsed={false}
            >
                <div className={style}>
                    <Form onSubmit={(v) => this.search(v)}>
                    {formApi => (
                        <form
                            onSubmit={formApi.submitForm}
                        >
                            <div className="fields">
                                <article>
                                    <label htmlFor="serialno">{_('field_serialno', 'SettingsDevice')}</label>
                                    <Text field="serialno" id="serialno" className="form-control" />
                                </article>
                                <article>
                                    <label htmlFor="description">{_('field_description', 'SettingsDevice')}</label>
                                    <Text field="description" id="description" className="form-control" />
                                </article>
                            </div>
                            <footer>
                                <span />
                                <button type="submit" className="btn btn-primary">
                                {_(`btn_search`, 'Settings')}
                                </button>
                            </footer>
                        </form>
                    )}
                    </Form>
                </div>
            </Box>
            
            <ReactTable
                {...localTableProps}
                data={items}
                columns={columns}
            />

            </>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/Settings/List/Device.tsx